import Repository from './repository';

const resource = '/templates';
export default {
	findTemplatesById(templateId) {
		return Repository.getWithAuth(`${resource}/${templateId}`);
	},
	findByMerchantId(payload) {
		return Repository.postWithAuth(`${resource}/find`, payload);
	},
	deleteTemplate(id) {
		return Repository.deleteWithAuth(`${resource}/${id}`);
	},
	updateTemplate(templateId, payload) {
		return Repository.putWithAuth(`${resource}/${templateId}`, payload);
	},
	sendTestEmail(payload) {
		return Repository.postWithAuth(`${resource}/testemail/send`, payload);
	},
};
